import React from "react";
import * as S from "./styles";
export var Chip = function Chip(t) {
  return React.createElement(S.Chip, Object.assign({}, t));
};
export default Chip;